import React, { useEffect } from "react";
import * as yup from "yup";
import { useField } from "formik";
import TextField from "@material-ui/core/TextField";
import NumberFormat from "react-number-format";
import { QuestionProps } from "../question";
import OutlinedDiv from "./outlined";
import FormQuestionSSN, { validator as ssnValidator } from "./ssn";
import { defaultValidator } from "./index";

export const validator = (
  question: QuestionProps,
  questionsMap: Record<string, QuestionProps>,
  parent?: string,
  index?: number,
): Record<string, yup.AnySchema> => {
  if (question.data?.mask === "us_social_security") return ssnValidator(question, questionsMap, parent, index);
  return defaultValidator(question, questionsMap, parent, index);
};

const TextInput = (props: any): React.ReactElement => {
  if (props.data?.mask === "us_social_security") return <FormQuestionSSN {...props} />;

  const [field, meta, helpers] = useField({ ...props });
  // Validate on transition:
  useEffect(() => () => {
    helpers.setTouched(true);
  }, []);

  if (props.type === "currency_usd") {
    return (

      <NumberFormat
        fullWidth
        variant="outlined"
        margin="dense"
        {...field}
        value={field.value}
        required={props.required}
        label={props.title}
        error={meta.touched && !!meta.error}
        helperText={meta.touched && meta.error}
        isNumericString
        thousandSeparator={true}
        decimalScale={0}
        prefix={"$"}
        customInput={TextField}
        onChange={() => null}
        onValueChange={({ value }: {value:string}) => {
          helpers.setValue(value === "" ? null : parseInt(value, 10));
        }}
      />
    );
  }

  return (
    <TextField
      fullWidth
      variant="outlined"
      margin="dense"
      {...field}
      value={field.value === null ? "" : field.value}
      required={props.required}
      label={props.title}
      error={meta.touched && !!meta.error}
      helperText={meta.touched && meta.error}
      type={props.type || "text"}
    />
  );
};

const OutlinedWrapper = (props: any): React.ReactElement => {
  if (props.title.length > 40) {
    const [, meta] = useField({ ...props });
    return (
      <OutlinedDiv
        fullWidth
        label={props.title}
        required={props.required}
        error={meta.touched && !!meta.error}>
        <TextInput {...props} title={""} />
      </OutlinedDiv>
    );
  }
  return <TextInput {...props} />;
};

OutlinedWrapper.validator = validator;
export default OutlinedWrapper;
